import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { CommunityGuard } from './guards/community.guard';
import { HomeComponent } from './components/home/home.component';
import { CommandComponent } from '@common/components/command/command.component';
import { ParticipantStatusGuard } from './guards/participant-status.guard';
import { AuthGuard } from './guards/auth.guard';
import { PrefCenterGuard } from './guards/pref-center.guard';
import { RedirectGuard } from './guards/redirect.guard';
import { FlowGuard } from './guards/flow.guard';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'kanagawa' },
    {
        path: ':community',
        canActivate: [RedirectGuard, CommunityGuard],
        data: {
            isProduction: environment.production,
        },
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            {
                path: 'info',
                loadChildren: () =>
                    import('./components/info/info.module').then(
                        (mod) => mod.InfoModule,
                    ),
            },
            {
                path: 'faq',
                loadChildren: () =>
                    import('./components/faq/faq.module').then(
                        (mod) => mod.FaqModule,
                    ),
            },
            {
                path: 'contact',
                loadChildren: () =>
                    import('./components/contact/contact.module').then(
                        (mod) => mod.ContactModule,
                    ),
            },
            {
                path: 'register',
                canActivate: [FlowGuard],
                loadChildren: () =>
                    import(
                        './components/product-flow/product-flow.module'
                    ).then((mod) => mod.ProductFlowModule),
            },
            {
                path: 'register-b2b',
                canActivate: [FlowGuard],
                loadChildren: () =>
                    import('./components/register/register.module').then(
                        (mod) => mod.RegisterModule,
                    ),
            },
            {
                path: 'preferences',
                canActivate: [PrefCenterGuard],
                loadChildren: () =>
                    import('./profile.module').then((mod) => mod.ProfileModule),
                data: { titleKey: 'preferences' },
            },
            {
                path: 'suppliers',
                loadChildren: () =>
                    import('./components/supplier/supplier.module').then(
                        (mod) => mod.SupplierModule,
                    ),
            },
            {
                path: 'error',
                loadChildren: () =>
                    import('./components/error/error.module').then(
                        (mod) => mod.ErrorModule,
                    ),
            },
            {
                path: 'cookie-policy',
                loadChildren: () =>
                    import(
                        './components/cookie-policy/cookie.policy.module'
                    ).then((mod) => mod.CookiePolicyModule),
            },
            {
                path: 'terms-and-conditions',
                loadChildren: () =>
                    import(
                        './components/terms-and-conditions/terms-and-conditions.component.module'
                    ).then((mod) => mod.TermsAndConditionsModule),
            },
            {
                path: 'privacy-policy',
                loadChildren: () =>
                    import(
                        './components/privacy-policy/privacy-policy.component.module'
                    ).then((mod) => mod.PrivacyPolicyComponentModule),
            },
            {
                path: 'commercial-transaction-law',
                loadChildren: () =>
                    import(
                        './components/commercial-transaction-law/commercial-transaction-law.module'
                    ).then((mod) => mod.CommercialTransactionLawModule),
            },
            {
                path: 'cancel',
                loadChildren: () =>
                    import('./components/cancel/cancel.module').then(
                        (mod) => mod.CancelModule,
                    ),
            },
            {
                path: 'do/:id/:command',
                canActivate: [ParticipantStatusGuard, AuthGuard],
                component: CommandComponent,
            },
            {
                path: 'unauthorized',
                loadChildren: () =>
                    import(
                        './components/unauthorized/unauthorized.module'
                    ).then((mod) => mod.UnauthorizedModule),
            },
            {
                path: 'no-proposal/:id',
                canActivate: [ParticipantStatusGuard, AuthGuard],
                loadComponent: () =>
                    import(
                        './components/no-proposal/no-proposal.component'
                    ).then((comp) => comp.NoProposalComponent),
            },
            { path: '**', redirectTo: 'home' },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
